import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "checked", ".indeterminate"]
const _hoisted_2 = ["for"]

import { ref, onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  indeterminate: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
  unknown: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: "update:modelValue", newVal: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const id = ref<string>("chkb0000");


onMounted(() => {
  id.value = "chk" + Math.floor(Math.random() * 1000000 + 1);
});

function onClick() {
  emit("update:modelValue", !props.modelValue);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: "checkbox",
      id: id.value,
      checked: !__props.unknown && __props.modelValue,
      ".indeterminate": !__props.unknown && __props.indeterminate,
      onInput: onClick,
      class: _normalizeClass(["custom-checkbox", { unknown: __props.unknown }])
    }, null, 42, _hoisted_1),
    _createElementVNode("label", { for: id.value }, _toDisplayString(__props.label), 9, _hoisted_2)
  ]))
}
}

})